// Whether "Go back" on a static page can step back in the history: only when
// the visitor came from a page of this site. Otherwise (a direct visit, a link
// from another site or an email) the link follows its href, the homepage.
export function canGoBack(referrer: string, origin: string): boolean {
  if (referrer === "") return false;
  try {
    return new URL(referrer).origin === origin;
  } catch {
    return false;
  }
}
